import { render, staticRenderFns } from "./PersonalSale.vue?vue&type=template&id=4d180406&scoped=true"
import script from "./PersonalSale.vue?vue&type=script&lang=js"
export * from "./PersonalSale.vue?vue&type=script&lang=js"
import style0 from "./PersonalSale.vue?vue&type=style&index=0&id=4d180406&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d180406",
  null
  
)

export default component.exports